'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (lmisType) {
  switch (lmisType) {
    case 'contextual':
      {
        return {
          lmisEvent: 'event118'
        };
      }

    case 'generic':
      {
        return {
          lmisEvent: 'event119'
        };
      }

    case 'fallback':
      {
        return {
          lmisEvent: 'event120'
        };
      }

    case 'none':
      {
        return {
          lmisEvent: 'event121'
        };
      }

    default:
      {
        return {
          lmisEvent: ''
        };
      }
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/evaluateLmisEvent.js
 ** module id = 432
 ** module chunks = 0
 **/